export default "__VITE_ASSET__DVY0NaIv__"